
import { Link } from "react-router-dom";
import { ProfileMenu } from "@/components/auth/ProfileMenu";
import { useEffect, useState } from "react";

interface ProjectHeaderProps {
  onNewProject?: () => void;
}

export function ProjectHeader({ onNewProject }: ProjectHeaderProps) {
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    // Check if font is already loaded
    if (document.fonts && document.fonts.check) {
      if (document.fonts.check('1em Brakle')) {
        setFontLoaded(true);
        return;
      }
    }

    // Wait for font to load
    const loadFont = async () => {
      try {
        if (document.fonts && document.fonts.load) {
          await document.fonts.load('1em Brakle');
          setFontLoaded(true);
        } else {
          // Fallback: wait a bit and assume it's loaded
          setTimeout(() => setFontLoaded(true), 200);
        }
      } catch (error) {
        // If font loading fails, use fallback font
        setFontLoaded(true);
      }
    };

    loadFont();
  }, []);

  return (
    <div className="space-y-6">
      <header className="flex justify-between items-center backdrop-blur-sm p-4 rounded-xl border border-white/5 glass-card shadow-lg">
        <Link 
          to="/" 
          className="text-3xl font-bold bg-gradient-to-r from-white via-purple-100 to-purple-200 text-transparent bg-clip-text transition-all duration-300"
          style={{ 
            fontFamily: fontLoaded ? 'Brakle, "Inter", sans-serif' : '"Inter", sans-serif'
          }}
        >
          PREPT.
        </Link>
        <div className="flex items-center gap-2">
          <ProfileMenu />
        </div>
      </header>
    </div>
  );
}
